module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.15.3@axios/index.js
// module id = 246
// module chunks = 0